import React, { useState, useRef, useEffect, Fragment } from "react";
import { withRouter } from "react-router-dom";

import { Col, Container, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import ContentSlider from "./components/ContentSlider";
import TrialAlert from "../../shared/components/payment/TrialAlert";
import ExportModal from "./components/exportreport/ExportModal";
import { _hasPermission	} from "../../shared/helpers/access";
import ReportIcon from 'mdi-react/ChartBarIcon';
import SocialIcon from 'mdi-react/ImageIcon';
import NewsletterIcon from 'mdi-react/EmailIcon';
import { height } from "@material-ui/system";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import searchActions from '../../redux/actions/searchActions';
import QuickStartGuide from '../../shared/components/QuickStartGuide';
import { Publisher } from "../../shared/pubsub/publisher.js";


import "./index.scss"
import { 
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  buildingFL,
  _replaceAbbreviations,
  StatusBadge,
  _getUnitFloorPlan
} from "../../shared/helpers/utils";
let content = {
  "reports": [
    {
      "name": "Market Report",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/resi-sales-screenshot.png",
      "line1": "PDF Download",
      "line2": "4 Page Report",
      "description": "Market report analyzing contracts and sales for condos, co-ops, and houses.",
      "link": "https://marketproof.com",
      "reportComponent": "PropertyType",
      "cardColor": "#FF5733",
      "svgIcon": "<svg viewBox='0 0 16 16' width='40px' height='40px'><path d='M15 1H1V3H15V1Z' fill='#000'/><path d='M1 5H3V15H1V5Z' fill='#000'/><path d='M5 13H15V15H5V13Z' fill='#000'/><path d='M15 9H5V11H15V9Z' fill='#000'/><path d='M5 5H15V7H5V5Z' fill='#000'/></svg>",
      "access" : "mc-resale",
      "coverPage" : true,
      "trackEdit" : true
    },
    {
      "name": "Rental Market",
      "badge": "New",
      "badgeColor": "#ff4861",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/resi-sales-screenshot.png",
      "line1": "PDF Download",
      "line2": "6 Page Report",
      "description": "Monthly median rents and supply by bedroom count, from StreetEasy market data.",
      "link": "https://marketproof.com",
      "reportComponent": "RentalReport",
      // StreetEasy publishes borough / neighborhood areas on a monthly cadence and nothing else,
      // so the controls are narrowed to what the data can answer: no zip, building or map-drawn
      // polygon, and no weekly interval.
      "searchTypes": ["borough", "neighborhood"],
      "dateIntervals": ["month", "quarter", "year"],
      "cardColor": "#28C2FF",
      "svgIcon": "<svg viewBox='0 0 16 16' width='40px' height='40px'><path d='M15 1H1V3H15V1Z' fill='#000'/><path d='M1 5H3V15H1V5Z' fill='#000'/><path d='M5 13H15V15H5V13Z' fill='#000'/><path d='M15 9H5V11H15V9Z' fill='#000'/><path d='M5 5H15V7H5V5Z' fill='#000'/></svg>",
      "access" : "mc-resale",
      "coverPage" : true,
      "trackEdit" : true
    },

    {
      "name": "New Dev Market",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/new-dev-report.png",
      "line1": "PDF Download",
      "line2": "1 Page Report",
      "description": "New development market report including contracts, sale prices, and inventory.",
      "link": "https://marketproof.com",
      "reportComponent": "NewDev",
      "cardColor": "#FFC300",
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M7 1H1V15H7V1Z' fill='#000'/><path d='M15 1H9V15H15V1Z' fill='#000'/></svg>",
      "access" : "mc-sponsor",
      "coverPage" : true,
      "trackEdit" : true
    },
    {
      "name": "Luxury Sales",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/new-dev-report.png",
      "line1": "PDF Download",
      "line2": "3 Page Report",
      "description": "Luxury market report for properties over $4M, covering contracts, sale prices, and inventory.",
      "link": "https://marketproof.com",
      "reportComponent": "LuxuryReport",
      "cardColor": "#9B33FF",
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M14 0H2V4H14V0Z' fill='#000'/><path d='M2 6H7V10H2V6Z' fill='#000'/><path d='M2 12H7V16H2V12Z' fill='#000'/><path d='M9 12H14V16H9V12Z' fill='#000'/><path d='M14 6H9V10H14V6Z' fill='#000'/></svg>",
      "access" : "mc-resale",
      "coverPage" : true,
      "trackEdit" : true
    },
    {
      "name": "Condo Market",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "PDF Download",
      "line2": "6 Page Report",
      "description": "Condo market report covering contracts, sale prices, and inventory.",
      "link": "https://marketproof.com",
      "reportComponent": "CondoReport",
      "cardColor": "#33D1FF",
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M7 1H1V5H7V1Z' fill='#000'/><path d='M7 7H1V15H7V7Z' fill='#000'/><path d='M9 1H15V9H9V1Z' fill='#000'/><path d='M15 11H9V15H15V11Z' fill='#000'/></svg>",
      "access" : "mc-resale",
      "coverPage" : true,
      "trackEdit" : true
    },
    {
      "name": "Co-op Market",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "PDF Download",
      "line2": "6 Page Report",
      "description": "Co-op market report covering contracts, sale prices, and inventory.",
      "link": "https://marketproof.com",
      "reportComponent": "CoopReport",
      "cardColor": "#FF8D1A",
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M3 4V0H7V4L3 4Z' fill='#000'/><path d='M3 6V10H7V6H3Z' fill='#000'/><path d='M9 6V10H13V6H9Z' fill='#000'/><path d='M9 0V4L13 4V0H9Z' fill='#000'/><path d='M3 16V12H7V16H3Z' fill='#000'/><path d='M9 12V16H13V12H9Z' fill='#000'/></svg>",
      "access" : "mc-resale",
      "coverPage" : true,
      "trackEdit" : true
    },
    {
      "name": "Townhouse Market",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "PDF Download",
      "line2": "1 Page Report",
      "description": "Townhouse market report covering contracts, sale prices, and inventory.",
      "link": "https://marketproof.com",
      "reportComponent": "TownhouseReport",
      "cardColor": "#33FFDA",
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M4 2H0V14H4V2Z' fill='#000'/><path d='M16 2H6V14H16V2Z' fill='#000'/></svg>",
      "access" : "mc-resale",
      "coverPage" : true,
      "trackEdit" : true
    },
    {
      "name": "Building Report",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/resi-sales-screenshot.png",
      "line1": "PDF Download",
      "line2": "4 Page Report",
      "description": "Building report showing building profile, performance and neighborhood analytics.",
      "link": "https://marketproof.com",
      "reportComponent": "BuildingMarketOverView",
      "cardColor": "#FF00FF",
      "svgIcon": `<svg viewBox="0 0 16 16"  width='40px' height='40px' fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M14 0H2V16H6V12H10V16H14V0ZM5 3H7V5H5V3ZM7 7H5V9H7V7ZM9 3H11V5H9V3ZM11 7H9V9H11V7Z" fill="#000000"></path> </g></svg>`,
      "access" : "mc-resale",
      "isBuilding":true,
      "urlPath" : "building-report",
      "coverPage" : true,
      "hideDate" :true
    },
    {
      "name": "Comp Report",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/resi-sales-screenshot.png",
      "line1": "PDF Download",
      "line2": "4 Page Report",
      "description": "Comp report evaluating the value of a subject property.",
      "link": "https://marketproof.com",
      "reportComponent": "BuildingMarketProofViewComp",
      "cardColor": "#1E90FF",
      "svgIcon": `<svg viewBox="0 0 16 16"  width='40px' height='40px' fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 7H13V1H9L9 15H13V9H16V7Z" fill="#000000"></path> <path d="M7 12H3V9H0V7H3V4L7 4L7 12Z" fill="#000000"></path> </g></svg>`,
      "access" : "mc-resale",
      "isBuilding":"comp",
      "Header": true,
      "Footer": true,
      "urlPath" : "comp-report",
      "coverPage" : true,
      "trackEdit" : true,
      "hideDate" :true
    },
    {
      "name": "Rental Comp Report",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/resi-sales-screenshot.png",
      "line1": "PDF Download",
      "line2": "4 Page Report",
      "description": "Rental comp report evaluating the market rent of a subject rental property.",
      "link": "https://marketproof.com",
      "reportComponent": "BuildingMarketProofViewCompRental",
      "cardColor": "#1E90FF",
      "svgIcon": `<svg viewBox="0 0 16 16"  width='40px' height='40px' fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 7H13V1H9L9 15H13V9H16V7Z" fill="#000000"></path> <path d="M7 12H3V9H0V7H3V4L7 4L7 12Z" fill="#000000"></path> </g></svg>`,
      "access" : "mc-resale",
      "isBuilding":"comp-rental",
      "Header": true,
      "Footer": true,
      "urlPath" : "rental-comp-report",
      "coverPage" : true,
      "trackEdit" : true,
      "hideDate" :true
    },
    {
      "name": "Listing Description",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/resi-sales-screenshot.png",
      "line1": "Embeddable Image",
      "description": "Showcase your exclusive property before listing publicly.",
      "link": "https://marketproof.com",
      "reportComponent": "ListingDesc",
      "reportType" : "listing-desc",
      "cardColor": "#1E90FF",
      "svgIcon": `<svg viewBox="0 0 16 16"  width='40px' height='40px' fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 7H13V1H9L9 15H13V9H16V7Z" fill="#000000"></path> <path d="M7 12H3V9H0V7H3V4L7 4L7 12Z" fill="#000000"></path> </g></svg>`,
      "access" : "mc-resale",
      "isBuilding":"listing-desc",
      "Header": false,
      "Footer": false,
      "isMedia":true,
      "defaultZoom": 100,
      "urlPath" : "listing-desc",
      "hideDate" :true
    },
  ],
  "social": [
    {
      "name": "Market Overview",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "IG | LinkedIn | FB",
      "line2": "4 Images (Zip)",
      "description": "Download images showcasing market trends for social sharing.",
      "link": "https://marketproof.com",
      "reportComponent": "SocialMarketOverview",
      "cardColor": "#33FFDA",
      "style": { "height": "1080", "width": "1080" },
      "downloadType": "zip",
      "Header": false,
      "Footer": false,
      "svgIcon": "<svg viewBox='0 0 16 16' width='40px' height='40px'><path d='M15 1H1V3H15V1Z' fill='#000'/><path d='M1 5H3V15H1V5Z' fill='#000'/><path d='M5 13H15V15H5V13Z' fill='#000'/><path d='M15 9H5V11H15V9Z' fill='#000'/><path d='M5 5H15V7H5V5Z' fill='#000'/></svg>",
      "access" : "mc-resale"
    },
    {
      "name": "New Dev Market",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "IG | LinkedIn | FB",
      "line2": "Image Download",
      "description": "Download a shareable image highlighting new dev inventory levels.",
      "link": "https://marketproof.com",
      "reportComponent": "SocialNewDev",
      "cardColor": "#FF7033",
      "style": { "height": "1080", "width": "1080" },
      "downloadType": "png",
      "Header": false,
      "Footer": false,
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M7 1H1V15H7V1Z' fill='#000'/><path d='M15 1H9V15H15V1Z' fill='#000'/></svg>",
      "access" : "mc-sponsor"
    },
    {
      "name": "Luxury Sales",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "IG | LinkedIn | FB",
      "line2": "3 Images (Zip)",
      "description": "Download images showcasing luxury market trends for social sharing.",
      "link": "https://marketproof.com",
      "reportComponent": "SocialLuxury",
      "cardColor": "#FF3381",
      "style": { "height": "1080", "width": "1080" },
      "downloadType": "zip",
      "Header": false,
      "Footer": false,
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M14 0H2V4H14V0Z' fill='#000'/><path d='M2 6H7V10H2V6Z' fill='#000'/><path d='M2 12H7V16H2V12Z' fill='#000'/><path d='M9 12H14V16H9V12Z' fill='#000'/><path d='M14 6H9V10H14V6Z' fill='#000'/></svg>",
      "access" : "mc-resale"
    },
    {
      "name": "Condo Market",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "IG | LinkedIn | FB",
      "line2": "6 Images (Zip)",
      "description": "Download images showcasing condo market trends for social sharing.",
      "link": "https://marketproof.com",
      "reportComponent": "SocialCondo",
      "cardColor": "#FFB347",
      "style": { "height": "1080", "width": "1080" },
      "downloadType": "zip",
      "Header": false,
      "Footer": false,
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M7 1H1V5H7V1Z' fill='#000'/><path d='M7 7H1V15H7V7Z' fill='#000'/><path d='M9 1H15V9H9V1Z' fill='#000'/><path d='M15 11H9V15H15V11Z' fill='#000'/></svg>",
      "access" : "mc-resale"
    },
    {
      "name": "Co-op Market",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "IG | LinkedIn | FB",
      "line2": "6 Images (Zip)",
      "description": "Download images showcasing co-op market trends for social sharing.",
      "link": "https://marketproof.com",
      "reportComponent": "SocialCoop",
      "cardColor": "#FF66FF",
      "style": { "height": "1080", "width": "1080" },
      "downloadType": "zip",
      "Header": false,
      "Footer": false,
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M3 4V0H7V4L3 4Z' fill='#000'/><path d='M3 6V10H7V6H3Z' fill='#000'/><path d='M9 6V10H13V6H9Z' fill='#000'/><path d='M9 0V4L13 4V0H9Z' fill='#000'/><path d='M3 16V12H7V16H3Z' fill='#000'/><path d='M9 12V16H13V12H9Z' fill='#000'/></svg>",
      "access" : "mc-resale"
    },
    {
      "name": "Townhouse Market",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "IG | LinkedIn | FB",
      "line2": "Image Download",
      "description": "Download images showcasing townhouse market trends for social sharing.",
      "link": "https://marketproof.com",
      "reportComponent": "SocialTownhouse",
      "cardColor": "#FFD700",
      "style": { "height": "1080", "width": "1080" },
      "downloadType": "png",
      "Header": false,
      "Footer": false,
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M4 2H0V14H4V2Z' fill='#000'/><path d='M16 2H6V14H16V2Z' fill='#000'/></svg>",
      "access" : "mc-resale"
    }
  ],
  "newsletter": [
    {
      "name": "Weekly $3M+ Contracts",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "Embeddable Image",
      "description": "Weekly $3M+ contract activity, listings, inventory, S&P 500, and interest rate trends for Manhattan.",
      "link": "https://marketproof.com",
      "reportComponent": "NewsletterCustom",
      "style": { "width": "1200", "height": "auto" },
      "downloadType": "png",
      "Header": false,
      "Footer": false,
      "cardColor": "#D59C1C",
      "badge": "De Niro Team",
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M2 1H14V3H2V1Z' fill='#000'/><path d='M2 5H8V7H2V5Z' fill='#000'/><path d='M2 9H14V11H2V9Z' fill='#000'/><path d='M2 13H10V15H2V13Z' fill='#000'/></svg>",
      "defaultZoom": 50,
      "hideDate": true,
      "access" : "mc-custom-email"
    },
    {
      "name": "Market Overview",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "Embeddable Image",
      "description": "Deliver contract and pricing trends to your email lists.",
      "link": "https://marketproof.com",
      "reportComponent": "NewsletterMarketTrends",
      "style": { "width": "1200", "height": "auto" },
      "downloadType": "png",
      "Header": false,
      "Footer": false,
      "cardColor": "#A633FF",
      "svgIcon": "<svg viewBox='0 0 16 16' width='40px' height='40px'><path d='M15 1H1V3H15V1Z' fill='#000'/><path d='M1 5H3V15H1V5Z' fill='#000'/><path d='M5 13H15V15H5V13Z' fill='#000'/><path d='M15 9H5V11H15V9Z' fill='#000'/><path d='M5 5H15V7H5V5Z' fill='#000'/></svg>",
      "access" : "mc-resale"
    },
    {
      "name": "Coming Soon Property",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/resi-sales-screenshot.png",
      "line1": "Embeddable Image",
      "description": "Showcase your exclusive property before listing publicly.",
      "link": "https://marketproof.com",
      "reportComponent": "NewsLetterComp",
      "style": { "width": "1200", "height": "auto" },
      "downloadType": "png",
      "cardColor": "#1E90FF",
      "svgIcon": `<svg viewBox="0 0 16 16"  width='40px' height='40px' fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 7H13V1H9L9 15H13V9H16V7Z" fill="#000000"></path> <path d="M7 12H3V9H0V7H3V4L7 4L7 12Z" fill="#000000"></path> </g></svg>`,
      "access" : "mc-resale",
      "isBuilding":"coming-soon",
      "Header": false,
      "Footer": false,
      "isMedia":true,
      "hideMarektproofBranding" : true,
      "defaultZoom": 50,
      "urlPath" : "coming-soon-email",
      "hideDate" :true,
      "bottomMargin" : 50
    },
    {
      "name": "New Dev Market",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "Embeddable Image",
      "description": "Deliver new development market trends to your email lists.",
      "link": "https://marketproof.com",
      "reportComponent": "NewsletterNewDev",
      "style": { "width": "1200", "height": "auto" },
      "downloadType": "png",
      "Header": false,
      "Footer": false,
      "cardColor": "#33FF8D",
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M7 1H1V15H7V1Z' fill='#000'/><path d='M15 1H9V15H15V1Z' fill='#000'/></svg>",
      "access" : "mc-sponsor"
    },
    {
      "name": "Luxury Sales",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "Embeddable Image",
      "description": "Deliver luxury market trends to your email lists.",
      "link": "https://marketproof.com",
      "reportComponent": "NewsletterLuxury",
      "style": { "width": "1200", "height": "auto" },
      "downloadType": "png",
      "Header": false,
      "Footer": false,
      "cardColor": "#FF3357",
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M14 0H2V4H14V0Z' fill='#000'/><path d='M2 6H7V10H2V6Z' fill='#000'/><path d='M2 12H7V16H2V12Z' fill='#000'/><path d='M9 12H14V16H9V12Z' fill='#000'/><path d='M14 6H9V10H14V6Z' fill='#000'/></svg>",
      "access" : "mc-resale"
    },
    {
      "name": "Condo Market",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "Embeddable Image",
      "description": "Deliver condo market trends to your email lists.",
      "link": "https://marketproof.com",
      "reportComponent": "NewsletterCondo",
      "style": { "width": "1200", "height": "auto" },
      "downloadType": "png",
      "Header": false,
      "Footer": false,
      "cardColor": "#33FFF6",
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M7 1H1V5H7V1Z' fill='#000'/><path d='M7 7H1V15H7V7Z' fill='#000'/><path d='M9 1H15V9H9V1Z' fill='#000'/><path d='M15 11H9V15H15V11Z' fill='#000'/></svg>",
      "access" : "mc-resale"
    },
    {
      "name": "Co-op Market",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "Embeddable Image",
      "description": "Deliver co-op market trends to your email lists.",
      "link": "https://marketproof.com",
      "reportComponent": "NewsletterCoop",
      "style": { "width": "1200", "height": "auto" },
      "downloadType": "png",
      "Header": false,
      "Footer": false,
      "cardColor": "#FF5733",
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M3 4V0H7V4L3 4Z' fill='#000'/><path d='M3 6V10H7V6H3Z' fill='#000'/><path d='M9 6V10H13V6H9Z' fill='#000'/><path d='M9 0V4L13 4V0H9Z' fill='#000'/><path d='M3 16V12H7V16H3Z' fill='#000'/><path d='M9 12V16H13V12H9Z' fill='#000'/></svg>",
      "access" : "mc-resale"
    },
    {
      "name": "Townhouse Market",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "Embeddable Image",
      "description": "Deliver townhouse market trends to your email lists.",
      "link": "https://marketproof.com",
      "reportComponent": "NewsletterTownhouse",
      "style": { "width": "1200", "height": "auto" },
      "downloadType": "png",
      "Header": false,
      "Footer": false,
      "cardColor": "#FFD633",
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M4 2H0V14H4V2Z' fill='#000'/><path d='M16 2H6V14H16V2Z' fill='#000'/></svg>",
      "access" : "mc-resale"
    }
  ],
  "postcards": [
    {
      "name": "Market Overview",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "Standard Postcard",
      "line2": "Front & Back Images (Zip)",
      "description": "Download a set of images of market trends in post card format.",
      "link": "https://marketproof.com",
      "reportComponent": "postCardMarketTrend",
      "style": { "width": "960", "height": "672" },
      "downloadType": "zip",
      "Header": false,
      "Footer": false,
      "cardColor": "#FF5733",
      "svgIcon": "<svg viewBox='0 0 16 16' width='40px' height='40px'><path d='M15 1H1V3H15V1Z' fill='#000'/><path d='M1 5H3V15H1V5Z' fill='#000'/><path d='M5 13H15V15H5V13Z' fill='#000'/><path d='M15 9H5V11H15V9Z' fill='#000'/><path d='M5 5H15V7H5V5Z' fill='#000'/></svg>",
      "access" : "mc-resale"
    },
    {
      "name": "New Dev Market",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "Standard Postcard",
      "line2": "Front & Back Images (Zip)",
      "description": "Download post card images capturing new development inventory highlights.",
      "link": "https://marketproof.com",
      "reportComponent": "postCardNewDev",
      "cardColor": "#33FF57",
      "style": { "width": "960", "height": "672" },
      "Header": false,
      "Footer": false,
      "downloadType": "zip",
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M7 1H1V15H7V1Z' fill='#000'/><path d='M15 1H9V15H15V1Z' fill='#000'/></svg>",
      "access" : "mc-sponsor"
    },
    {
      "name": "Luxury Sales",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "Standard Postcard",
      "line2": "Front & Back Images (Zip)",
      "description": "Download a set of images for luxury market trends for social media sharing.",
      "link": "https://marketproof.com",
      "reportComponent": "postCardLuxury",
      "cardColor": "#33A1FF",
      "style": { "width": "960", "height": "672" },
      "Header": false,
      "Footer": false,
      "downloadType": "zip",
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M14 0H2V4H14V0Z' fill='#000'/><path d='M2 6H7V10H2V6Z' fill='#000'/><path d='M2 12H7V16H2V12Z' fill='#000'/><path d='M9 12H14V16H9V12Z' fill='#000'/><path d='M14 6H9V10H14V6Z' fill='#000'/></svg>",
      "access" : "mc-resale"
    },
    {
      "name": "Condo Market",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "Standard Postcard",
      "line2": "Front & Back Images (Zip)",
      "description": "Access downloadable images covering condo market trends for social media.",
      "link": "https://marketproof.com",
      "reportComponent": "postCardCondo",
      "cardColor": "#FF33A1",
      "style": { "width": "960", "height": "672" },
      "Header": false,
      "Footer": false,
      "downloadType": "zip",
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M7 1H1V5H7V1Z' fill='#000'/><path d='M7 7H1V15H7V7Z' fill='#000'/><path d='M9 1H15V9H9V1Z' fill='#000'/><path d='M15 11H9V15H15V11Z' fill='#000'/></svg>",
      "access" : "mc-resale"
    },
    {
      "name": "Co-op Market",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "Standard Postcard",
      "line2": "Front & Back Images (Zip)",
      "description": "Download images highlighting co-op market trends for your social channels.",
      "link": "https://marketproof.com",
      "reportComponent": "postCardCoop",
      "cardColor": "#FF6633",
      "style": { "width": "960", "height": "672" },
      "Header": false,
      "Footer": false,
      "downloadType": "zip",
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M3 4V0H7V4L3 4Z' fill='#000'/><path d='M3 6V10H7V6H3Z' fill='#000'/><path d='M9 6V10H13V6H9Z' fill='#000'/><path d='M9 0V4L13 4V0H9Z' fill='#000'/><path d='M3 16V12H7V16H3Z' fill='#000'/><path d='M9 12V16H13V12H9Z' fill='#000'/></svg>",
      "access" : "mc-resale"
    },
    {
      "name": "Townhouse Market",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/Coming+Soon.png",
      "line1": "Standard Postcard",
     "line2": "Front & Back Images (Zip)",
      "description": "Download images of townhouse market trends for your social media sharing.",
      "link": "https://marketproof.com",
      "reportComponent": "postCardTownHouse",
      "cardColor": "#FF9933",
      "style": { "width": "960", "height": "672" },
      "Header": false,
      "Footer": false,
      "downloadType": "zip",
      "svgIcon": "<svg width='40px' height='40px' viewBox='0 0 16 16'><path d='M4 2H0V14H4V2Z' fill='#000'/><path d='M16 2H6V14H16V2Z' fill='#000'/></svg>",
      "access" : "mc-resale"
    }
  ],
  "marketbuildings": [
    {
      "name": "Building Overview",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/resi-sales-screenshot.png",
      "line1": "PDF Download",
      "line2": "4 Page Report",
      "description": "Building report showing building profile, performance and neighborhood analytics.",
      "link": "https://marketproof.com",
      "reportComponent": "BuildingMarketOverView",
      "cardColor": "#FF5733",
      "svgIcon": "<svg viewBox='0 0 16 16' width='40px' height='40px'><path d='M15 1H1V3H15V1Z' fill='#000'/><path d='M1 5H3V15H1V5Z' fill='#000'/><path d='M5 13H15V15H5V13Z' fill='#000'/><path d='M15 9H5V11H15V9Z' fill='#000'/><path d='M5 5H15V7H5V5Z' fill='#000'/></svg>",
      "access" : "mc-resale",
      "isBuilding":true
    },
    {
      "name": "Building Overview MarketProof",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/resi-sales-screenshot.png",
      "line1": "PDF Download",
      "line2": "4 Page Report",
      "description": "Market report analyzing contracts and sales for condos, co-ops, and houses.",
      "link": "https://marketproof.com",
      "reportComponent": "BuildingMarketProofView",
      "cardColor": "#FF5733",
      "svgIcon": "<svg viewBox='0 0 16 16' width='40px' height='40px'><path d='M15 1H1V3H15V1Z' fill='#000'/><path d='M1 5H3V15H1V5Z' fill='#000'/><path d='M5 13H15V15H5V13Z' fill='#000'/><path d='M15 9H5V11H15V9Z' fill='#000'/><path d='M5 5H15V7H5V5Z' fill='#000'/></svg>",
      "access" : "mc-resale",
      "isBuilding":true,
      "Header": false,
      "Footer": false,
    },
    {
      "name": "Building Overview MarketProof",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/resi-sales-screenshot.png",
      "line1": "PDF Download",
      "line2": "4 Page Report",
      "description": "Market report analyzing contracts and sales for condos, co-ops, and houses.",
      "link": "https://marketproof.com",
      "reportComponent": "BuildingMarketProofViewComp",
      "cardColor": "#FF5733",
      "svgIcon": "<svg viewBox='0 0 16 16' width='40px' height='40px'><path d='M15 1H1V3H15V1Z' fill='#000'/><path d='M1 5H3V15H1V5Z' fill='#000'/><path d='M5 13H15V15H5V13Z' fill='#000'/><path d='M15 9H5V11H15V9Z' fill='#000'/><path d='M5 5H15V7H5V5Z' fill='#000'/></svg>",
      "access" : "mc-resale",
      
      "Header": false,
      "Footer": false,
    },
   
 ],
 "video": [
   {
      "name": "Luxury Market",
      "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/resi-sales-screenshot.png",
      "line1": "AI Video",
      "line2": "Portrait (9:16)",
      "description": "1 minute video or script analyzing the sales of $4M+ properties.",
      "link": "https://marketproof.com",
      "reportComponent": "VideoLuxuryReport",
      "cardColor": "#8e3ccb",
      "svgIcon": '<svg viewBox="0 0 16 16" fill="none" width="40px" height="40px" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C2.89543 0 2 0.895431 2 2V14C2 15.1046 2.89543 16 4 16H12C13.1046 16 14 15.1046 14 14V2C14 0.895431 13.1046 0 12 0H4ZM12 3H4V13H12V3Z" fill="#000000"></path> </g></svg>',
      "access" : "mc-resale",
      "downloadType" : "pdf",
      "reportType" : "video-script",
      "template_id" : "5c06661ec9954aaf8a0b72be5020e6be",
      "payloadMap" :  {
          "cn": {
              "name": "cn",
              "type": "text",
              "properties": {
                  "content": ""
              },
              "data_map" : { "type" : "textContent", "selector" : ".contracts-signed"}
          },
          "pf": {
              "name": "pf",
              "type": "text",
              "properties": {
                  "content": ""
              },
              "data_map" : { "type" : "textContent", "selector" : ".ppsf"}
          },
          "DATE": {
              "name": "DATE",
              "type": "text",
              "properties": {
                  "content": ""
              },
              "data_map" : { "type" : "textContent", "selector" : ".date-range"}
          },
          "title": {
              "name": "title",
              "type": "text",
              "properties": {
                  "content": ""
              },
              "data_map" : { "type" : "textContent", "selector" : ".report-name"}
          },
          "location": {
              "name": "location",
              "type": "text",
              "properties": {
                  "content": ""
              },
              "data_map" : { "type" : "textContent", "selector" : ".location"}
          },
          "logo_image": {
              "name": "logo_image",
              "type": "image",
              "properties": {
                  "url": "",
                  "asset_id": null,
                  "fit": "none"
              },
              "data_map" : { "type" : "attr", "attr" : "src", "selector" : ".header-logo"}
          },
          "PERCENT_CHG": {
              "name": "PERCENT_CHG",
              "type": "text",
              "properties": {
                  "content": ""
              },
              "data_map" : { "type" : "textContent", "selector" : ".percent-change"}
          },
          "scene_1_script": {
              "name": "scene_1_script",
              "type": "text",
              "properties": {
                  "content": ""
              },
              "data_map" : { "type" : "textContent", "selector" : ".scene-1"}
          },
          "scene_2_script": {
              "name": "scene_2_script",
              "type": "text",
              "properties": {
                  "content": ""
              },
              "data_map" : { "type" : "textContent", "selector" : ".scene-2"}
          },
          "scene_3_script": {
              "name": "scene_3_script",
              "type": "text",
              "properties": {
                  "content": ""
              },
              "data_map" : { "type" : "textContent", "selector" : ".scene-3"}
          },
          "PPSF_PERCENT_CHG": {
              "name": "PPSF_PERCENT_CHG",
              "type": "text",
              "properties": {
                  "content": ""
              },
              "data_map" : { "type" : "textContent", "selector" : ".ppsf-percent-change"}
          }
      }
    },
   {
     "name": "Market Overview",
     "img": "https://marketproof-hosting.s3.amazonaws.com/marketing-center/resi-sales-screenshot.png",
     "line1": "AI Video",
     "line2": "Landscape (16:9)",
     "description": "1 minute video or script analyzing the current market for condos, co-ops, and houses.",
     "link": "https://marketproof.com",
     "reportComponent": "VideoMarketReport",
     "cardColor": "#00F5D4",
     "svgIcon": '<svg viewBox="0 0 16 16" width="40px" height="40px" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M16 2H0V14H16V2ZM5 10.5C6.38071 10.5 7.5 9.38071 7.5 8C7.5 6.61929 6.38071 5.5 5 5.5C3.61929 5.5 2.5 6.61929 2.5 8C2.5 9.38071 3.61929 10.5 5 10.5ZM10 5H14V7H10V5ZM14 9H10V11H14V9Z" fill="#000000"></path> </g></svg>',
     "access" : "mc-resale",
     "downloadType" : "pdf",
     "reportType" : "video-script"
   }]
};

const CustomSolution = ({title, copy}) => {
    return (

        <div className="mc-marketing">
          <div className="callout-text">
          <h3>{_capitalizeText(title.slice(0, title.lastIndexOf(' ')))}{' '}
           <br/><strong>{_capitalizeText(title.split(' ').pop())}</strong></h3>
          <p>
           {copy}
          </p>
          </div>
          <button className="mc_intercom_launcher" onClick={(e) => {
            // if (window.Intercom) {
            //     // Trigger the custom event in Intercom
            //     window.Intercom('trackEvent', 'custom_marketing_request');
            //     window.Intercom('show');
            // } else {
            //     console.error('Intercom is not loaded.');
            // }
          }}>Contact Us</button>
        </div>
       
    )
}

const MarketingCenter = ({ t, user, actions, searchTags, location }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reportComponent, setReportComponent] = useState(false);
  const [layoutStyle, setLayoutStyle] = useState(null);
  const [reportItem, setReportItem] = useState(null);
  const [isHeaderAvailable,setIsHeaderAvailable]=useState(false);
  const [isFooterAvailable, setIsFooterAvailable]=useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
   const [submit, setSubmit]=useState(true)
   const [isBuilding, setIsBuilding]=useState(false);
   const [isMedia, setIsMedia]=useState(false)
   const {addTag} = actions;
   const {removeTag, clearTags} = actions;
  const [isDirectReport, setIsDirectReport]=useState(false); 
   
   const isLastRow = location.pathname.endsWith("postcards"); // Replace "postcards" with your last row's ID
   
   useEffect(() => {
    
     
     const pathParts = location.pathname.split("/").filter(Boolean); // remove empty strings
     
     // Only proceed if there are exactly 2 segments (e.g. ['marketing-center', 'comp-report'])
     if (pathParts.length === 3) {
       const slug = pathParts[2]; // e.g. 'comp-report'
     
       const allItems = Object.values(content).flat(); // Flatten all content categories
       const matchedItem = allItems.find(function(item) {
         return item.urlPath === slug;
       });
     
       if (matchedItem) {
         if (matchedItem.reportComponent) {
           setIsDirectReport(true);
           toggleModal(matchedItem.reportComponent);
         }
         setLayoutStyle(matchedItem.style ? { ...matchedItem.style } : null);
         setIsHeaderAvailable(matchedItem.hasOwnProperty("Header") ? matchedItem.Header : true);
         setIsFooterAvailable(matchedItem.hasOwnProperty("Footer") ? matchedItem.Footer : true);
         setReportItem(matchedItem);
         if (matchedItem.isMedia && setIsMedia) setIsMedia(true);
         setSubmit(true);
         console.log(setIsBuilding, matchedItem)
         if (setIsBuilding && matchedItem.isBuilding) setIsBuilding(matchedItem.isBuilding);
       }else{
         setIsDirectReport(false);
       }
     }else{
       const sectionId = location.pathname.split("/").pop();
       
        if (sectionId) {
          const section = document.getElementById(sectionId);
          if (section) {
            const offset = 100; // Header height offset
            const elementPosition = section.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - offset;
       
            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth",
            });
          }
        }
     }
   }, [location]);
   
   
  const toggleModal = (report) => {
  
    if(!isModalOpen){
      setScrollPosition(window.scrollY);
      // document.body.style.overflow = 'hidden'; // Disable scrolling
      // document.body.style.position = 'fixed';
      // document.body.style.top = `-${window.scrollY}px`;
     
      
      setIsModalOpen(true);
      Publisher.publish(`track-mp.aiMarketingCenterOpen`, {
        user: user,
        customData: report,
      });
    }else{
      setIsModalOpen(false);
      setReportItem(null);
      setIsDirectReport(false);
      setIsBuilding(false);
   
      // document.body.style.overflow = '';
      // document.body.style.position = '';
      // document.body.style.top = '';
      
      // Restore scroll position
      console.log(scrollPosition)
      setTimeout(() => {
        window.scrollTo(0, scrollPosition);
      }, 500);
    }
    setReportComponent(report);
    
    
  };
  
  useEffect(() => {
    
   console.log(isBuilding, searchTags)
   if(isBuilding && searchTags.filter(tag => tag.type !== "building").length>0){
     
     searchTags.filter(tag => tag.type !== "building").forEach(tag => {
       removeTag(tag);
     })
   }
   if((!isBuilding && !(reportItem && reportItem.isBuilding)) && searchTags.filter(tag => tag.type == "building").length>0){
     searchTags.filter(tag => tag.type == "building").forEach(tag => {
       removeTag(tag);
     })
   }
  }, [isBuilding, reportItem]);
  
  if(!user) return null;
  
  if(!_hasPermission(user, 'mc-sponsor')){
    Object.keys(content).forEach(key => {
      content[key] = content[key].filter(item => item.access !== "mc-sponsor");
    });
  }
  if(!_hasPermission(user, 'mc-custom-email')){
    Object.keys(content).forEach(key => {
      content[key] = content[key].filter(item => item.access !== "mc-custom-email");
    });
  }
  return (
    <>
    <ExportModal
      parentFetchInProgress={false}
      html={null}
      reportParams={{}}
      toggleModal={toggleModal}
      isModalOpen={isModalOpen}
      reportComponent={reportComponent}
      layoutStyle={layoutStyle}
      isHeaderAvailable={isHeaderAvailable}
      isFooterAvailable={isFooterAvailable}
      reportItem={reportItem}
      setSubmit={setSubmit}
      submit={submit}
      isBuilding={isBuilding}
      setIsBuilding={setIsBuilding}
      addTag={addTag}
      clearTags={clearTags}
      isMedia={isMedia}
      setIsMedia={setIsMedia}
      setLayoutStyle={setLayoutStyle}
    />
    {!isDirectReport ? 
    <Container className="professional__container marketing__center">
      <Row >
        <Col md={12}>
          <h3 className="page-title">{"Marketing Center"}</h3>
          <h3 className="page-subhead subhead">
            Customize and download branded content to promote your business
            
            
          </h3>
        </Col>
      </Row>
      <Row>
        <Col md={12} className={"mb-3"}>
          <TrialAlert />
        </Col>
        
      </Row>
      <QuickStartGuide link={"https://help.marketproof.com/en/articles/10552067-introduction-to-marketing-center"} copy={"Want to see how Marketing Center works?"} linkCopy={"How-to Videos"} />
      {content.reports && content.reports.length>0 ? 
      <Row id="reports">
        <ContentSlider
          toggleModal={toggleModal}
          title={"Market Reports"}
          subhead={
            "Create brandable reports to deliver personalized analysis to your customers"
          }
          label={`${content.reports.length} Reports`}
          items={content.reports.filter(r => !r.urlPath)}
          setLayoutStyle={setLayoutStyle}
          setIsHeaderAvailable={setIsHeaderAvailable}
          setIsFooterAvailable={setIsFooterAvailable}
          setSubmit={setSubmit}
          setReportItem={setReportItem}
          color="#FF206E" 
          setIsBuilding={setIsBuilding}
          icon={<ReportIcon color="#FFF" style={{marginTop:-8}}/>}
          CallOut={<CustomSolution title={"Want custom reports?"} copy={"Explore how custom marketing solutions can meet your goals."} />}
        />
      </Row>
      : null}
      
      {/* {content.marketbuildings && content.marketbuildings.length>0 ? 
      <Row>
        <ContentSlider
          toggleModal={toggleModal}
          title={"Building Reports"}
          subhead={"Download personalized, ready-to-print postcards featuring market analysis"}
          label={`${content.marketbuildings.length} Buildings`}
          items={content.marketbuildings}
          setLayoutStyle={setLayoutStyle}
          setSubmit={setSubmit}
          setIsHeaderAvailable={setIsHeaderAvailable}
          setIsFooterAvailable={setIsFooterAvailable}
          setReportItem={setReportItem}
          color="#FF691E" 
          setIsBuilding={setIsBuilding}
          icon={<NewsletterIcon color="#FF691E" style={{marginTop:-5}}/>}
          CallOut={ <CustomSolution title={"Want custom building reports?"} copy={"Explore how custom marketing solutions can meet your goals."} />}
      
        />
      </Row> 
      : null} */}
      
      {content.social && content.social.length>0 ? 
      <Row id="social">
        <ContentSlider
          toggleModal={toggleModal}
          title={"Social Content"}
          subhead={
            "Share social posts optimized for various platforms with targeted content"
          }
          label={`${content.social.length}  Social Posts`}
          items={content.social}
          setLayoutStyle={setLayoutStyle}
          setSubmit={setSubmit}
          setIsHeaderAvailable={setIsHeaderAvailable}
          setIsFooterAvailable={setIsFooterAvailable}
          setReportItem={setReportItem}
          color="#FFD23F" 
          icon={<SocialIcon color="#FFD23F" style={{marginTop:-5}}/>}
          CallOut={<CustomSolution title={"Want custom social layouts?"} copy={"Explore how custom marketing solutions can meet your goals."} />}

        />
      </Row>
      : null}
      
      {content.newsletter && content.newsletter.length>0 ? 
      <Row id="email">
        <ContentSlider
          toggleModal={toggleModal}
          title={"Email Templates"}
          subhead={"Add high-impact content to your email marketing"}
          label={`${content.newsletter.length} Email Templates`}
          items={content.newsletter}
          setLayoutStyle={setLayoutStyle}
          setSubmit={setSubmit}
          setIsHeaderAvailable={setIsHeaderAvailable}
          setIsFooterAvailable={setIsFooterAvailable}
          setReportItem={setReportItem}
          setIsBuilding={setIsBuilding}
          setIsMedia={setIsMedia}
          color="#FF691E" 
          icon={<NewsletterIcon color="#FF691E" style={{marginTop:-5}}/>}
          CallOut={ <CustomSolution title={"Want custom newsletters?"} copy={"Explore how custom marketing solutions can meet your goals."} />}
        />
      </Row>
      : null}
 
      {_hasPermission(user, 'mc-post-cards') && content.postcards && content.postcards.length>0 ? 
      <Row id="postcards">
        <ContentSlider
          toggleModal={toggleModal}
          title={"postcards"}
          subhead={"Download personalized, ready-to-print postcards featuring market analysis"}
          label={`${content.postcards.length} Postcards`}
          items={content.postcards}
          setLayoutStyle={setLayoutStyle}
          setSubmit={setSubmit}
          setIsHeaderAvailable={setIsHeaderAvailable}
          setIsFooterAvailable={setIsFooterAvailable}
          setReportItem={setReportItem}
          color="#FF691E" 
          icon={<NewsletterIcon color="#FF691E" style={{marginTop:-5}}/>}
          CallOut={ <CustomSolution title={"Want custom postcards?"} copy={"Explore how custom marketing solutions can meet your goals."} />}
      
        />
      </Row> 
      : null}
           
      {_hasPermission(user, 'mc-video') && content.video && content.video.length>0 ? 
      <Row id="video">
        <ContentSlider
          toggleModal={toggleModal}
          title={"AI Videos"}
          subhead={"Get customizable AI generated videos or scripts for your video channels"}
          label={`${content.video.length} Videos`}
          items={content.video}
          setLayoutStyle={setLayoutStyle}
          setSubmit={setSubmit}
          setIsHeaderAvailable={setIsHeaderAvailable}
          setIsFooterAvailable={setIsFooterAvailable}
          setReportItem={setReportItem}
          color="#FF691E" 
          icon={<NewsletterIcon color="#FF691E" style={{marginTop:-5}}/>}
          CallOut={ <CustomSolution title={"Want custom postcards?"} copy={"Explore how custom marketing solutions can meet your goals."} />}
      
        />
      </Row> 
      : null}
      <Row>
        <Col md={12}>
          <h3 className="page-title"></h3>
          <h3 className="page-subhead subhead"></h3>
        </Col>
      </Row>
 
     
      {isLastRow && <div style={{ height: "50vh" }}></div>}

    </Container> : null}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    searchTags: Array.isArray(state.search.searchTags)
      ? state.search.searchTags.slice().map((tag) => {
          if (
            tag.type === "neighborhood" &&
            !tag.data.hood.includes("manhattan")
          ) {
            return {
              ...tag,
              id: `${tag.data.hood.toLowerCase().replace(/\s+/g, "-")}_${
                tag.data.boro
              }`,
            };
          } else if (
            tag.type === "neighborhood" &&
            tag.data.hood.includes("manhattan")
          ) {
            return {
              ...tag,
              id: `${tag.data.hood
                .replace("manhattan", "")
                .trim()
                .toLowerCase()
                .replace(/\s+/g, "-")}_${tag.data.boro}`,
            };
          } else return tag;
        })
      : [],
  };
};

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(searchActions, dispatch) };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MarketingCenter));
